import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';

const ContractsPage: React.FC = () => {
  const { t } = useTranslation();
  
  const columns: GridColDef[] = [
    { field: 'name', headerName: t('contracts.name'), flex: 1, minWidth: 250 },
    { field: 'owner_name', headerName: t('contracts.ownerName'), width: 200 },
    { field: 'funder_name', headerName: t('contracts.funderName'), width: 200 },
    { field: 'value', headerName: t('contracts.value'), width: 150 },
  ];

  const fields = [
    { 
      name: 'name', 
      label: t('contracts.name'), 
      type: 'text' as const, 
      required: true,
      width: 'full' as const // Full width on all screens
    },
    { 
      name: 'owner_name', 
      label: t('contracts.ownerName'), 
      type: 'text' as const, 
      required: true,
      width: 'third' as const // 1/3 width (3 items per row on desktop)
    },
    { 
      name: 'funder_name', 
      label: t('contracts.funderName'), 
      type: 'text' as const,
      width: 'third' as const
    },
    { 
      name: 'value', 
      label: t('contracts.value'), 
      type: 'number' as const,
      width: 'third' as const
    },
    { 
      name: 'currency', 
      label: t('contracts.currency'), 
      type: 'currency' as const,
      width: 'third' as const
    },
    { 
      name: 'contractor_id', 
      label: t('contracts.contractorName'), 
      type: 'select' as const,
      foreignKey: {
        table: 'companies',
        valueField: 'id',
        labelField: 'name'
      },
      width: 'third' as const
    },
    { 
      name: 'tender_id', 
      label: t('contracts.tender'), 
      type: 'select' as const,
      foreignKey: {
        table: 'tenders',
        valueField: 'id',
        labelField: 'tender_name'
      },
      width: 'third' as const
    },
  ];

  return (
    <GenericTablePage
      tableName="contracts"
      title={t('contracts.title')}
      columns={columns}
      fields={fields}
      detailPath={(id) => `/contracts/${id}`}
      editPath={(id) => (id ? `/contracts/${id}/edit` : '/contracts/new')}
    />
  );
};

export default ContractsPage;
